import React, {FC, useEffect, useRef, useState} from "react";
import cls from "./customTopBar.module.scss"
import Link from "next/link";
import {Logout} from "../../../svg";
import {ICustomTopBar} from "./MainLayout";
import {domainUrl} from "../../../helper";
import {useRouter} from "next/router";
import CustomCurrDropDown from "./CustomCurrDropDown";
import MenuRenderer from "../MenuRenderer";
import CustomIndicatorDropDownBody from "./CustomHeader/CustomIndicators/CustomIndicatorDropDownBody";
import {useDispatch, useSelector} from "react-redux";
import {IState} from "../../../types/state";
import AccountNavigationMenu from "../../account/AccountNavigationMenu";
import shopApi from "../../../api/shop";
import {setAuth, setCustomerGroupID, setToken} from "../../../store/customer";
import {getCartDataMount} from "../../../store/cart";
import {wishListRemoveAllItems} from "../../../store/wishlist";
import { apiUrlWithStore } from "../../../helper";
import {AddCartToken} from "../../../store/token";

const CustomTopBar: FC<ICustomTopBar> = (
    {
        dbName,
        locales = [],
        currencies: [{
            code: selectedCurr = "",
            symbol: selectedSymbol = ""
        } = {}, ...currencies] = [],
        selectedLocaleImg,
        selectedRate,
        selectedLocale,
        translationsData,
        isSocialLinksActive,
        showAccount,
        showTopBar,
        topMenus,
        domain,
        themeOptions: {
            font_family = ""
        } = {},
    }
) => {
    const currRef = useRef<any>(null)
    const langRef = useRef<any>(null)
    const leftBarRef = useRef<any>(null)
    const containerRef = useRef<any>(null);
    const [menusRowWidth, setMenusRowWidth] = useState(991)
    useEffect(() => {
        setMenusRowWidth(containerRef.current?.offsetWidth - leftBarRef?.current?.offsetWidth)
    }, [containerRef.current?.offsetWidth, leftBarRef?.current?.offsetWidth]);

    if (!showTopBar) return <></>;

    const [personal, setPersonal] = useState<string>('');
    const [
        {},
        setOpenLang
    ] = useState({langMenuClassName: "none", langDDAClassName: ""});
    const [isClient, setIsClient] = useState(false);
    const [loginDropOpen, setLoginDropOpen] = useState<boolean>(false);
    const customer = useSelector((state: IState) => state.customer);
    const { cartToken } = useSelector((state: IState) => state.cartToken) || {}
    const {asPath, ...router} = useRouter();
    const signed = useSelector((state: IState) => state.customer.authenticated);
    const dispatch = useDispatch();
    const searchRef = useRef<HTMLDivElement | null>(null)
    const [links, setLinks] = useState<JSX.Element[]>([]);
    const isDownloadableOrder = !!useSelector((state: IState) => state.orders.downloadable).length;

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (langRef && langRef.current && !langRef.current.contains(e.target as Node)) {
                setOpenLang({langMenuClassName: "none", langDDAClassName: ""})
            }
        }
        const handleSignInClick = (e: MouseEvent) => {
            if (searchRef && searchRef.current && !searchRef.current.contains(e.target as Node)) {
                setLoginDropOpen(false)
            }
        }

        document.addEventListener("mousedown", (e) => {
            handleSignInClick(e);
            handleClick(e);
        })

        return () => document.removeEventListener("mousedown", (e) => {
            handleSignInClick(e);
            handleClick(e)
        })
    }, [langRef])

    useEffect(() => {
        setIsClient(true)
    }, []);
    const handleLangClick = () => {
        setOpenLang(({langMenuClassName}) => {
            if (langMenuClassName === "none") {
                return {
                    langMenuClassName: "block",
                    langDDAClassName: "rotT_fms"
                }
            }
            return { langMenuClassName: "none", langDDAClassName: ""}
        })
    }
    //TODO!!! comment this handleClick remove it after testing is done
    // const handleLangItemClick = (localeCode: string) => {
    //     router.push(router.asPath, router.asPath, {locale: localeCode}).then(r => r);
    // }
    const handleAccDropClick = () => {
        setLoginDropOpen((prevState) => !prevState)
    }
    const logout = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        dispatch(setAuth(false));
        dispatch(setCustomerGroupID(1))
        dispatch(setToken(""));

        shopApi.getCustomerLogoutToken(customer.token)
            .then(item => {
                if (!item.ok) return;
                shopApi.getCheckoutCartToken()
                    .then(res => res.api_token && dispatch(AddCartToken(res.api_token)))
            })
        dispatch(getCartDataMount(cartToken, { token: "" }, selectedLocale, selectedRate ? selectedRate.code : ""));
        dispatch(wishListRemoveAllItems())
        router.push("/");
    };

    useEffect(() => {
        const abortController = new AbortController();
        const { signal } = abortController;

        if (customer.token) {
            fetch(apiUrlWithStore(`/api/customer/get?token=${customer.token}`), { signal })
                .then((response) => response.json())
                .then((res) => res && setPersonal(`${res.data.first_name} ${res.data.last_name}`))
                .catch((err) => console.error(err));
        }
        return () => abortController.abort();
    }, [customer.token]);

    useEffect(() => {
        const baseLinks = [
            {
                title: translationsData.PersonalInformation,
                url: "profile",
                id: 1,
            },
            {
                title: translationsData.MyOrders,
                url: "orders",
                id: 2,
            },
            ...(isDownloadableOrder ? [{
                title: translationsData.DownloadableProducts,
                url: "downloadable-products",
                id: 3,
            }] : []),
            {
                title: translationsData.Address,
                url: "addresses",
                id: 4,
            },
            {
                title: translationsData.SignOut,
                url: "logout",
                icon: <Logout />,
                id: 5,
            }
        ];

        const jsxLinks = baseLinks.map((link) => {
            const classes = `${cls["account-nav__item"]} ${router.route.includes(link.url) ? cls["account-nav__item--active"] : ""}`;
            const signOutProps = link.url === "logout" ? { onClick: logout, className: cls.logout } : {};

            return (
                <li key={link.id} className={classes}>
                    <Link href={`/account/${link.url}`}>
                        <a {...signOutProps}>
                            {link.icon ? <span>{link.icon}</span> : null}
                            {link.title}
                        </a>
                    </Link>
                </li>
            );
        });

        setLinks(jsxLinks);
    }, [isDownloadableOrder]);

    const handleCurrencyDropdown = {
        true: <CustomCurrDropDown selectedCurr={selectedCurr} selectedSymbol={selectedSymbol} currencies={currencies}/>,
        false: null
    }

    const accountToggle = {
        "true": (
            isClient && signed ? <div className={`${cls["my_account"]} ${cls["nav-panel__item-custom"]}`}>
                <Link href='/account/profile' prefetch={false}>
                    <a>{translationsData.MyAccount}</a>
                </Link>
                <div className={cls["nav-panel__account-nav"]}>
                    <AccountNavigationMenu links={links} username={personal}/>
                </div>
            </div> : (
                <div className={cls["account_indicators"]} ref={searchRef}>
                    <div onClick={handleAccDropClick}>
                        <a>{translationsData?.SignIn}</a>
                    </div>
                    <div className={`${cls[`account-dropdown__${loginDropOpen ? 'opened' : 'closed'}`]}`}>
                        <CustomIndicatorDropDownBody
                            setOpen={() => {}}
                            translationsData={translationsData}
                            selectedRate={selectedRate}
                            selectedLocale={selectedLocale}
                            isSocialLinksActive={isSocialLinksActive}
                            dbName={dbName}
                        />
                    </div>
                    <span>|</span>
                    <Link href="/signup">
                        <a>{translationsData?.SignUp}</a>
                    </Link>
                </div>
            )
        ),
        "false": <></>
    }
    return (
        <div className={cls["top-bar"]}>
            <div className="container">
                <div className={cls["top-bar-main"]} ref={containerRef}>
                    <div className={cls.topbar_buttons} ref={leftBarRef}>
                        {locales.length ? (
                            <div id="forLanguage" className={`${cls["language-button"]} ${cls["locale-bttn"]}`} onClick={handleLangClick} ref={langRef}>
                                {locales?.map(({code, id, locale_image, selected = false}) => {
                                    if (selected) {
                                        return (
                                            <span className={cls.selected_locale}>
                                                <img src={domainUrl(`${dbName}${selectedLocaleImg}`)} alt="Language" loading="lazy"/>
                                            </span>
                                        )
                                    }
                                    return (
                                        <Link href={asPath} locale={code} key={id}>
                                            <a className={cls.menu_item}>
                                                <img src={domainUrl(`${dbName}${locale_image}`)} alt="Language" loading="lazy"/>
                                            </a>
                                        </Link>
                                    )
                                })}
                            </div>
                        ) : null}
                        {handleCurrencyDropdown[`${!!currencies.length}`]}
                    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                        <MenuRenderer domain={domain} dbName={dbName} topMenus={topMenus} font_family={font_family} menusRowWidth={menusRowWidth} />
                        {accountToggle[`${showAccount}`]}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CustomTopBar;
